import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBomb: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBomb"><Path d="M17.5 14C17.5 18.1421 14.1421 21.5 10 21.5C5.85786 21.5 2.5 18.1421 2.5 14C2.5 9.85786 5.85786 6.5 10 6.5C14.1421 6.5 17.5 9.85786 17.5 14Z" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 8.5L17.5 6.5" stroke="currentColor"/><Path d="M19.5 4.5L21.25 2.75" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 7.5H22.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 3.5V1.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBomb;
